import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreAgentSessionsModule,
  DatastoreAgentsModule,
  DatastorePjpAssistantEnqueueModule,
  DatastoreUsersModule,
  DatastoreUsersSelfModule,
} from '@freelancer/datastore/collections';
import { DirectivesModule } from '@freelancer/directives';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { PJPAssistantChatboxBodyComponent } from './pjp-assistant-chatbox/pjp-assistant-chatbox-body/pjp-assistant-chatbox-body.component';
import { PJPAssistantChatboxHeaderComponent } from './pjp-assistant-chatbox/pjp-assistant-chatbox-header/pjp-assistant-chatbox-header.component';
import { PJPAssistantChatboxInputComponent } from './pjp-assistant-chatbox/pjp-assistant-chatbox-input/pjp-assistant-chatbox-input.component';
import { PJPAssistantChatboxComponent } from './pjp-assistant-chatbox/pjp-assistant-chatbox.component';
import { PJPAssistantComponent } from './pjp-assistant.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreAgentSessionsModule,
    DatastoreAgentsModule,
    DatastorePjpAssistantEnqueueModule,
    DatastoreUsersModule,
    DatastoreUsersSelfModule,
    DirectivesModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [
    PJPAssistantChatboxBodyComponent,
    PJPAssistantChatboxComponent,
    PJPAssistantChatboxHeaderComponent,
    PJPAssistantChatboxInputComponent,
    PJPAssistantComponent,
  ],
  exports: [PJPAssistantComponent],
})
export class PJPAssistantModule {}
